import React, { Component } from 'react';
import './UrlWindow.css';
import * as helpers from './helpers';
import logo from './images/logo.png';
import closeFormIcon from './images/close-message.svg';

class URLWindow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hide: false,
    };
  }

  onCloseClick = (value) => {
    this.setState({ hide: true });
  };

  onPopoutClick = () => {
    window.open(this.props.url, '_blank');
  };

  componentWillUnmount() {
    window.emitter.removeListener('sidebarChanged', this.sidebarEmitter);
    // this.sidebarEmitter.remove();
    document.removeEventListener('keydown', this.escFunction, false);
  }

  componentDidMount() {
    helpers.waitForLoad('settings', Date.now(), 30, () => {
      this.storageKey = window.config.storageKeys.URLDontShowAgain;

      try {
        if (this.props.honorDontShow) {
          const saved = this.getStorage();
          if (saved !== null && saved !== undefined) {
            if (
              saved.find((item) =>
                item.url !== undefined
                  ? item.url.toLowerCase() === this.props.url.toLowerCase()
                  : false
              )
            )
              this.setState({ hide: true });
          }
        }
      } catch (e) {
        console.log(e);
      }

      document.addEventListener('keydown', this.escFunction, false);
    });
    // LISTEN FOR SIDEPANEL CHANGES
    this.sidebarEmitter = (isSidebarOpen) => this.sidebarChanged(isSidebarOpen);
    window.emitter.addListener('sidebarChanged', this.sidebarEmitter);
  }

  isDontShow = () => {
    try {
      if (this.props.honorDontShow) {
        const saved = this.getStorage();
        if (saved !== null && saved !== undefined) {
          return saved.find((item) =>
            item.url !== undefined
              ? item.url.toLowerCase() === this.props.url.toLowerCase()
              : false
          );
        } else {
          return false;
        }
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }

    if (this.props.honorDontShow) {
      const saved = this.getStorage();
      if (saved.includes(this.props.url)) return true;
      else return false;
    }
  };

  sidebarChanged = (isSidebarOpen) => {
    this.forceUpdate();
  };

  escFunction = (event) => {
    if (event.keyCode === 27) {
      this.setState({ hide: true });
    }
  };

  onDontShowThisAgain = () => {
    this.saveToStorage();
  };

  saveToStorage = () => {
    let item = { url: this.props.url, dateAdded: new Date().toLocaleString() };
    helpers.appendToStorage(this.storageKey, item);
    this.setState({ hide: true });
  };

  // GET STORAGE
  getStorage() {
    const storage = localStorage.getItem(this.storageKey);
    if (storage === null) return [];

    const data = JSON.parse(storage);
    return data;
  }

  render() {
    // DONT RENDER IF WERE NOT SHOWING, OTHERWISE ALL DATA/IMAGES FROM URL LINK WILL DOWNLOAD
    if (this.isDontShow()) return <div />;

    let className = '';
    if (this.state.hide) className = 'fs-hidden';
    else if (this.props.mode === 'full') className = 'full';
    else if (!window.sidebarOpen) className = 'full';

    let hideScrollClassName = '';
    if (this.props.hideScroll)
      hideScrollClassName = 'fs-url-window-content-no-scroll';
    return (
      <div className={!this.state.hide ? 'information-container' : ''}>
        <div id="fs-url-window-container" className={className}>
          <div className="fs-url-window-header">
            <div className="fs-url-window-header-title">Informacije</div>
            {/* <div className="fs-url-window-header-popout-button" title="Open New Window">
            <button className="fs-button fs-button-blue fs-url-window-header-button" onClick={this.onPopoutClick}>
              <img src={images["new-window.png"]} alt="new window" />
            </button>
          </div> */}
            <div className="fs-url-window-header-close-button" title="Zatvori">
              <button
                style={{ fontWeight: 'bolder' }}
                className="close-message-button fs-url-window-header-button"
                onClick={this.onCloseClick}
              >
                <img
                  src={closeFormIcon}
                  style={{ height: '10px' }}
                  alt="Icon"
                />
              </button>
            </div>
          </div>
          <div
            id="fs-url-window-content"
            className={
              this.props.showFooter
                ? 'fs-url-window-content with-footer ' + hideScrollClassName
                : 'fs-url-window-content ' + hideScrollClassName
            }
          >
            <div className="welcome-message">
              <h1 className="message-header">WEB GIS PORTAL</h1>
              <a
                href="https://vodovodgracanica.ba/"
                target="_blank"
                rel="noreferrer"
                className="message-komunalac-name"
              >
                JP "VODOVOD I KANALIZACIJA" D.O.O. GRAČANICA
              </a>

              <div className="message-image-container">
                <img className="message-image" src={logo} alt="logo" />
              </div>

              <h2 className="message-welcome-title">DOBRO DOŠLI</h2>
              <p className="message-content">
                Web GIS portal vodovoda i kanalizacije u gradu Gračanici Vam
                omogućava pregled i korištenje podataka vodovodnog sistema i
                sistema kanalizacije, prije svega za internu upotrebu od strane
                svih uposlenika u preduzeću, a potom i za uposlenike gradskih
                službi, te za naša partnerska preduzeća i u konačnici i za
                korisnike naših usluga.
              </p>
              <div className="message-contact-section">
                <b>Full Solution-Potpuno rješenje d.o.o.</b> -{' '}
                <a href="mailto:info@fullsolution.org">info@fullsolution.org</a>
                <br />
              </div>
            </div>
          </div>
          <div
            className={
              this.props.showFooter ? 'fs-url-window-footer' : 'fs-hidden'
            }
          >
            <button
              className="do-not-show-again-button"
              onClick={this.onDontShowThisAgain}
            >
              Ne prikazuj više
            </button>
            <button className="close-message-btn" onClick={this.onCloseClick}>
              Zatvori
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default URLWindow;

// IMPORT ALL IMAGES
const images = importAllImages(
  require.context('./images', false, /\.(png|jpe?g|svg|gif)$/)
);
function importAllImages(r) {
  let images = {};
  r.keys().map((item, index) => (images[item.replace('./', '')] = r(item)));
  return images;
}
